<template>
  <div>
    <el-card class="box-card">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-card shadow="never" class="box-card" style="height: 100%">
            <template #header>
              <div>
                <span>Media Contract </span>
              </div>
            </template>
            <div>
              <el-form label-position="top" :model="FormData">
                <el-form-item label="Media Contract Company" :required="true">
                  <base-input placeholder="" style="width: 100%" label="" :clearable="true">
                    <el-select clearable v-model="FormData.MediaCompanyEntityCode" class="select-primary" size="large"
                      filterable style="width: 100%" placeholder="Media Contract Compan">
                      <el-option class="select-primary" key="AA" label="AA" value="AA">
                      </el-option>
                      <el-option class="select-primary" key="AM" label="AM" value="AM">
                      </el-option>
                      <el-option class="select-primary" key="TH" label="TH" value="TH">
                      </el-option>
                    </el-select>
                  </base-input>
                </el-form-item>
                <el-form-item label="Contract Code" :required="true">
                  <baseInput style="width: 100%" v-model="FormData.MediaContractCode" placeholder="Contract Code"
                    clearable />
                </el-form-item>
                <el-form-item label="Customer">
                  <base-input placeholder="" style="width: 100%">
                    <el-select clearable v-model="FormData.MediaCustomerCode" class="select-primary" size="large" filterable
                      style="width: 100%" placeholder="Customer">
                      <el-option class="select-primary" v-for="item in CustomerSalesList" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </el-form-item>
                <el-form-item label="Remark">
                  <baseInput style="width: 100%">
                    <el-input style="width: 100%" type="textarea" v-model="FormData.MediaRemark" placeholder="Remark"
                      autocomplete="off" :autosize="{ minRows: 5 }" />
                  </baseInput>
                </el-form-item>
                <el-form-item>
                  <base-button type="primary" @click="searchMedia">Get Media Contract Number</base-button>
                </el-form-item>
                <el-form-item label="">
                  <label style="font-size: 18px">{{
                    FormData.MediaReust
                  }}</label>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never" class="box-card" style="height: 100%">
            <template #header>
              <div>
                <span>Production Contract </span>
              </div>
            </template>
            <div>
              <el-form label-position="top" :model="FormData">
                <el-form-item label="Production Contract Company" :required="true">
                  <!-- <baseInput
                    style="width: 100%"
                    v-model="FormData.ProductionCompanyEntityCode"
                    placeholder="Media Contract Company"
                    clearable
                  /> -->
                  <base-input placeholder="" style="width: 100%" label="" :clearable="true">
                    <el-select clearable v-model="FormData.ProductionCompanyEntityCode" class="select-primary"
                      size="large" filterable style="width: 100%" placeholder="Production Contract Compan">
                      <el-option class="select-primary" key="AA" label="AA" value="AA">
                      </el-option>
                      <el-option class="select-primary" key="AM" label="AM" value="AM">
                      </el-option>
                      <el-option class="select-primary" key="GP" label="GP" value="GP">
                      </el-option>
                      <el-option class="select-primary" key="TH" label="TH" value="TH">
                      </el-option>
                    </el-select>
                  </base-input>
                </el-form-item>
                <el-form-item label="Contract Code" :required="true">
                  <baseInput style="width: 100%" v-model="FormData.ProductionContractCode" placeholder="Contract Code"
                    clearable />
                </el-form-item>
                <el-form-item label="Customer">
                  <base-input placeholder="" style="width: 100%">
                    <el-select clearable v-model="FormData.ProductionCustomerCode" class="select-primary" size="large" filterable
                      style="width: 100%" placeholder="Customer">
                      <el-option class="select-primary" v-for="item in CustomerSalesList" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </el-form-item>
                <el-form-item label="Remark">
                  <baseInput style="width: 100%">
                    <el-input style="width: 100%" type="textarea" v-model="FormData.ProductionRemark" placeholder="Remark"
                      autocomplete="off" :autosize="{ minRows: 5 }" />
                  </baseInput>
                </el-form-item>
                <el-form-item>
                  <base-button type="primary" @click="searchProduction">Get Production Contract Number</base-button>
                </el-form-item>
                <el-form-item label="">
                  <label style="font-size: 18px">{{
                    FormData.ProductionReust
                  }}</label>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script setup>
// // import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import { ElMessage, ElMessageBox } from 'element-plus';
// import tablecolumn from '@/components/tablecolumn';
// import PubSub from 'pubsub-js';

// import { useContractStore } from '@/store/contract';

// // router
// import router from '@/router';
import contractnet from '@/network/contractnet';
import optional from '@/network/optional';

// // api
// import basicapi from '@/network/optional';

// // icon
// import { Edit, Search } from '@element-plus/icons-vue';

// // tool
// import {
//   formatterCellMoney,
//   formatterCellDate,
//   formatterCellDateTime,
// } from '@/assets/js/formatter';

const FormData = reactive({
  MediaCompanyEntityCode: '',
  MediaContractCode: '',
  MediaReust: '',
  ProductionCompanyEntityCode: '',
  ProductionContractCode: '',
  ProductionReust: '',
});
const CustomerSalesList = ref([]);

onBeforeMount(async () => {
  // 读取基本的Option
  var result = await optional
        .getContractingPartyData('en')
        .then((res) => res)
        .catch((error) => error);
  // const result = await optional.getContractingPartyList('en').then((res) => res);
  // 销售员选项
   CustomerSalesList.value =result.data.agAdvertiserOptions;
});


const searchMedia = () => {
  if (
    FormData.MediaCompanyEntityCode.length < 1 ||
    FormData.MediaContractCode.length < 1
  ) {
    ElMessage({
      message: 'Please fill in mandatory field!',
      type: 'warning',
    });
    return;
  }

  ElMessageBox.confirm(
    'Confirm to get Media Number (' +
    FormData.MediaCompanyEntityCode +
    'XXXXXXXX' +
    FormData.MediaContractCode +
    ') ',
    'Get Contract Number',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(async () => {
    if(FormData.MediaCustomerCode){
     var dataInfo = CustomerSalesList.value.find(
        (p) => p.value == FormData.MediaCustomerCode
      );
      FormData.MediaCustomer= dataInfo?.label || '';
    }
    contractnet
      .GetContractNo(
        FormData.MediaCompanyEntityCode,
        FormData.MediaContractCode,
        FormData.MediaCustomer,
        FormData.MediaCustomerCode,
        FormData.MediaRemark,
      )
      .then((res) => {
        FormData.MediaReust = 'Number: ' + res.data.data;
      });
  });
};
const searchProduction = () => {
  if (
    FormData.ProductionCompanyEntityCode.length < 1 ||
    FormData.ProductionContractCode.length < 1
  ) {
    ElMessage({
      message: 'Please fill in mandatory field!',
      type: 'warning',
    });
    return;
  }
  ElMessageBox.confirm(
    'Confirm to get Production Number (' +
    FormData.ProductionCompanyEntityCode +
    'XXXXXXXX' +
    FormData.ProductionContractCode +
    ') ',
    'Get Contract Number',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(async () => {
    if(FormData.ProductionCustomerCode){
     var dataInfo = CustomerSalesList.value.find(
        (p) => p.value == FormData.ProductionCustomerCode
      );
      FormData.ProductionCustomer= dataInfo?.label || '';
    }
    contractnet
      .GetContractNo(
        FormData.ProductionCompanyEntityCode,
        FormData.ProductionContractCode,
        FormData.ProductionCustomer,
        FormData.ProductionCustomerCode,
        FormData.ProductionRemark,
      )
      .then((res) => {
        FormData.ProductionReust = 'Number: ' + res.data.data;
      });
  });
};
</script>
<style>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}
</style>
